// ** React Imports
import { Fragment, useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useLocation, useSearchParams } from 'react-router-dom';
import { Offcanvas, Spinner, Button, ProgressBar } from 'react-bootstrap';
import { toast, Toaster } from 'react-hot-toast';
import { useForm, useFieldArray } from 'react-hook-form';
import parse from 'html-react-parser';
import { RiErrorWarningFill } from "react-icons/ri";
import styled from 'styled-components';
import Chart from 'chart.js';

// ** Reactstrap Imports
import { Row, Col, Container, Card } from "reactstrap";

// ** Icons Imports
import { Menu } from "react-feather"

// ** Services Imports
import { progressDimensionListService } from '../../services/dimensionService';
import { indicatorListService } from '../../services/indicatorService';
import { progressSectionQuestionService, sectionQuestionService } from '../../services/sectionService';
import { userProgressAnswerService } from '../../services/userQ&AService';
import { getProgressAssociatedCompaniesSubmissionService } from '../../services/associatedCompamiesSubmissionDetalisService';

// ** Components Imports
import SubmissionEndModal from '../components/modal/SubmissionEndModal';
import UploadedDocumentsModal from '../components/modal/UploadedDocumentsModal';
import ShowPdfModal from '../components/modal/ShowPdfModal';

// Utility-Service
import { getUser, getToken } from "../../utility/AuthService";
import Header from "../components/layouts/Navbar";
import Footer from '../components/layouts/Footer'

//redux
import { selectLanguageUse } from '../../redux/slices/language.Slice'
import CryptoJS from 'crypto-js';
import classNames from 'classnames';

const StyledQuestionPage = styled.div`
    min-height: 100vh;
    background-color: #f8f9fa;
    width: 100%;
    margin: 0;
    padding: 1rem;

    .progress-indicator {
        background-color: white;
        padding: 1.5rem;
        border-radius: 0.5rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
    
    .progress-bar-custom {
        height: 1rem;
        border-radius: 0.5rem;
        background-color: #e9ecef;
    }
    
    .progress-bar-custom .progress-bar {
        background-color: #0d6efd;
        border-radius: 0.5rem;
    }
    
    .progress-text {
        color: #6c757d;
        font-weight: 500;
    }
    
    .question-header {
        background-color: white;
        padding: 1.5rem;
        border-radius: 0.5rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
    
    .dimension-title {
        color: #2c3e50;
        font-weight: 600;
    }
    
    .indicator-info {
        border-left: 4px solid #0d6efd;
    }
    
    .question-section {
        background-color: white;
        border: none;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        transition: transform 0.2s ease-in-out;
    }
    
    .question-section:hover {
        transform: translateY(-2px);
    }
    
    .question-title {
        color: #2c3e50;
    }
    
    .tooltip {
        display: flex;
        align-items: center;
        background-color: #f8f9fa;
        padding: 0.5rem;
        border-radius: 0.25rem;
    }
    
    .form-check {
        margin-bottom: 0.5rem;
    }
    
    .form-check-input {
        cursor: pointer;
    }
    
    .form-check-label {
        cursor: pointer;
        user-select: none;
    }
    
    .statement-option {
        background-color: #f8f9fa;
        padding: 1rem;
        border-radius: 0.5rem;
    }
    
    .statement-option p {
        color: #2c3e50;
    }
    
    .input-field input,
    .calculation-field input {
        padding: 0.5rem;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        width: 100%;
        max-width: 300px;
    }
    
    .calculation-info {
        font-size: 0.875rem;
        color: #6c757d;
    }
    
    @media (max-width: 768px) {
        .question-page {
            padding: 1rem !important;
        }
        
        .question-header {
            padding: 1rem;
        }
        
        .options-list {
            margin-top: 1rem !important;
        }
    }
    
    .submit-section {
        margin-top: 2rem;
        padding: 2rem;
        background-color: white;
        border-radius: 0.5rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }
    
    .submit-section .btn {
        min-width: 250px;
        padding: 0.75rem 1.5rem;
    }
    
    .submit-section .btn-outline-primary {
        border-width: 2px;
    }
    
    .submit-section .btn:disabled {
        cursor: not-allowed;
        opacity: 0.7;
    }
    
    @media (max-width: 768px) {
        .submit-section {
            padding: 1rem;
        }
        
        .submit-section .btn {
            width: 100%;
            min-width: unset;
        }
    }

    .progress-question-page {
        .question-header {
            margin-bottom: 2rem;
            padding-bottom: 1rem;
            border-bottom: 1px solid #eee;

            .dimension-title {
                font-size: 1.5rem;
                font-weight: 600;
                margin-bottom: 0.5rem;
            }

            .indicator-info {
                color: #666;
                font-size: 1rem;
                line-height: 1.5;
            }
        }

        .question-section {
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            padding: 1.5rem;
            margin-bottom: 1.5rem;

            .question-title {
                font-size: 1.1rem;
                font-weight: 500;
                margin-bottom: 1rem;
            }

            .options-list {
                padding-left: 1rem;
            }
        }
    }

    .completion-summary {
        background: white;
        border-radius: 12px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        margin: 2rem auto;
        max-width: 800px;

        .completion-icon {
            color: #28a745;
        }

        .completion-stats {
            .stat-item {
                text-align: center;
                padding: 1rem;
                background: #f8f9fa;
                border-radius: 8px;
                margin: 0.5rem;

                h4 {
                    color: #1e3250;
                    font-size: 2rem;
                    font-weight: bold;
                    margin: 0;
                }

                p {
                    color: #6c757d;
                    margin: 0.5rem 0 0 0;
                    font-size: 0.9rem;
                }
            }
        }

        .completion-actions {
            .btn {
                padding: 0.75rem 1.5rem;
                font-weight: 500;
                border-radius: 8px;
                transition: all 0.2s ease;

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }
            }
        }

        .next-steps {
            border-top: 1px solid #dee2e6;
            padding-top: 2rem;
            margin-top: 2rem;

            h4 {
                color: #2c3e50;
                font-weight: 600;
            }

            .next-steps-options {
                display: flex;
                flex-wrap: wrap;
                gap: 1rem;
                justify-content: center;

                .btn {
                    padding: 0.75rem 1.5rem;
                    font-weight: 500;
                    border-radius: 8px;
                    transition: all 0.2s ease;
                    min-width: 200px;

                    &:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                    }

                    &.btn-info {
                        background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
                        border: none;
                        color: white;

                        &:hover {
                            background: linear-gradient(135deg, #138496 0%, #117a8b 100%);
                        }
                    }

                    &.btn-outline-secondary {
                        border: 2px solid #6c757d;
                        color: #6c757d;

                        &:hover {
                            background: #6c757d;
                            color: white;
                        }
                    }
                }
            }
        }
    }
`;

const getYesAnswers = (item, languageUse, currentDimension, sectionQues) => {
    if (currentDimension === 'Demographics') {
        if (Array.isArray(item?.yesAnswers)) {
            return languageUse === 'English' ? 
                item.yesAnswers : 
                item.yesAnswers.map(yesAnswerItem => 
                    sectionQues?.find(sectionItem => sectionItem?._id === item?._id)?.questionId?.yes_options[
                        sectionQues?.find(sectionItem => sectionItem?._id === item?._id)?.questionId?.yes_options_Malay?.findIndex(optionItem => optionItem === yesAnswerItem)
                    ]
                );
        }
        if (typeof item?.yesAnswers === 'string') {
            return languageUse === 'English' ? 
                [item.yesAnswers] : 
                [sectionQues?.find(sectionItem => sectionItem?._id === item?._id)?.questionId?.yes_options[
                    sectionQues?.find(sectionItem => sectionItem?._id === item?._id)?.questionId?.yes_options_Malay?.findIndex(optionItem => optionItem === item.yesAnswers)
                ]];
        }
        return [];
    }
    return languageUse === 'English' ? 
        (Array.isArray(item?.yesAnswers) ? item.yesAnswers : []) : 
        (Array.isArray(item?.yesAnswersMalay) ? item.yesAnswersMalay : []);
};

const getOtherAnswer = (item, languageUse, sectionQues) => {
    if (!item?.otherAnswer) return null;

    const itemOther = item.otherAnswer;
    const questionData = sectionQues?.find(sectionItem => sectionItem?._id === item?.id)?.questionId;

    if (languageUse === 'English') {
        if (questionData?.yes_options && !questionData.yes_options.includes(itemOther)) {
            return itemOther;
        }
    } else {
        if (questionData?.yes_options_Malay && !questionData.yes_options_Malay.includes(itemOther)) {
            return itemOther;
        }
    }
    return null;
};

const ProgressQuestionPage = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const { id } = useParams()
    const [searchParams] = useSearchParams();
    const userId = searchParams.get('userId')

    const dimensionID = props.dimensionID;
    const authToken = getToken()

    // State variables
    const [isLoading, setLoading] = useState(false)
    const [isQuestionLoading, setQuestionLoading] = useState(false)
    const [offset, setOffset] = useState(0)
    const [sectionQues, setSectionQues] = useState([])
    const [savedSubmitButton, setSavedSubmitButton] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [uploadedDocumentsModal, setUploadedDocumentsModal] = useState(false);
    const [showPdfModalShow, setShowPdfModalShow] = useState(false);
    const [pdfItem, setPdfItem] = useState(null);
    const [isAssessmentComplete, setIsAssessmentComplete] = useState(false);

    const viewPage = location.pathname.includes('view')
    const decryptedSubId = CryptoJS.AES.decrypt(id, 'mySecretKey').toString(CryptoJS.enc.Utf8);
    const user = getUser()
    const languageUse = useSelector(selectLanguageUse || user?.language)

    // Modal handlers
    const handleModalShow = () => setModalShow(!modalShow);
    const UploadedDocumentsModaltoggle = () => setUploadedDocumentsModal(!uploadedDocumentsModal);
    const handleShowPdfModalShow = () => setShowPdfModalShow(!showPdfModalShow);

    const { register, control, watch, handleSubmit, reset, setValue } = useForm({});
    const { fields: sectionReqField } = useFieldArray({
        control,
        name: 'sectionReqAnswers'
    });

    const watchSectionReqAnswers = watch("sectionReqAnswers");
    const redStar = ''

    // Add logging for debugging
    useEffect(() => {
        console.log('Auth Token:', authToken);
        console.log('Dimension ID:', dimensionID);
        console.log('User ID:', userId);
        console.log('Encrypted ID:', id);
        
        try {
            const decryptedSubId = CryptoJS.AES.decrypt(id, 'mySecretKey').toString(CryptoJS.enc.Utf8);
            console.log('Decrypted ID:', decryptedSubId);
        } catch (error) {
            console.error('Decryption Error:', error);
            toast.error('Error decrypting submission ID');
        }
    }, [authToken, dimensionID, userId, id]);

    // Add debug logging for props
    useEffect(() => {
        console.log('Props received:', {
            dimensionID: props.dimensionID,
            currentDimension: props.currentDimension,
            selectedIndicator: props.selectedIndicator,
            sectionQues
        });
    }, [props, sectionQues]);

    // Add error boundary
    if (!authToken) {
        return <div className="text-center p-5">Please log in to continue</div>;
    }

    if (!dimensionID) {
        return <div className="text-center p-5">Loading dimension data...</div>;
    }

    if (!id) {
        return <div className="text-center p-5">No submission ID provided</div>;
    }

    /**
        * @function getQuestions
        * @param
        * @description handle API to get the Questions
    */
    const getSectionQuestions = async () => {
        try {
            setQuestionLoading(true)
            console.log('Fetching questions with:', {
                authToken: authToken ? 'present' : 'missing',
                proGress_Dimension: dimensionID,
                submissionId: decryptedSubId
            });
            
            const result = await progressSectionQuestionService({
                authToken,
                proGress_Dimension: dimensionID,
                submissionId: decryptedSubId
            });
            
            console.log('API Response:', result?.data);
            console.log('Questions data:', result?.data?.data?.list);
            
            if (!result?.data?.data?.list) {
                throw new Error('No question data received from API');
            }
            
            setSectionQues(result?.data?.data?.list)
            setQuestionLoading(false)

            // Log the sections and questions after setting state
            console.log('Updated sectionQues:', result?.data?.data?.list);
        } catch (error) {
            console.error('API Error:', error);
            setSectionQues([])
            setQuestionLoading(false)
            toast.error(error?.response?.data?.message || error.message || 'Something went wrong')
        }
    };

    useEffect(() => {
        if (dimensionID) {
            setOffset(0)
        }
    }, [dimensionID]);

    useEffect(() => {
        if (dimensionID) {
            getSectionQuestions()
        } else {
            console.warn('No dimension ID available');
        }
    }, [dimensionID, offset])

    /**
        * @function getAssociatedSectionQuestions
        * @param
        * @description handle API to get the Questions
    */
    const getAssociatedSectionQuestions = async () => {
        try {
            const result = await getProgressAssociatedCompaniesSubmissionService({
                authToken,
                submissionId: decryptedSubId,
                proGress_Dimension: dimensionID,
                userId: userId
            });
            setSectionQues(result?.data?.data?.list)
        } catch (error) {
            setSectionQues([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    useEffect(() => {
        if (userId) {
            getAssociatedSectionQuestions()
        }
    }, [dimensionID, userId])

    /**
        * @function answerSubmit
        * @param data
        * @description api to submit the answer
    */
    const answerSubmit = async (data) => {
        if (!data?.sectionReqAnswers) {
            toast.error('No answers to submit');
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            
            // Enhanced validation for different question types
            const validAnswers = data.sectionReqAnswers.filter((item, index) => {
                // Ensure each answer has an id
                if (!item?.id && sectionQues[index]?._id) {
                    item.id = sectionQues[index]._id;
                }

                if (props?.currentDimension === 'Demographics') {
                    return Array.isArray(item?.yesAnswers) && item.yesAnswers.length > 0;
                }
                
                // For checkbox type questions
                if (Array.isArray(item)) {
                    return item.length > 0;
                }
                
                // For multi-statement questions
                if (item && typeof item === 'object' && !Array.isArray(item)) {
                    return Object.values(item).some(value => 
                        Array.isArray(value) && value.length > 0
                    );
                }
                
                // For input/calculation type questions
                if (typeof item === 'string' || typeof item === 'number') {
                    return item !== '' && item !== undefined && item !== null;
                }
                
                return false;
            });

            if (validAnswers.length === 0) {
                toast.error('Please provide at least one answer before submitting');
                setLoading(false);
                return;
            }

            // Ensure all answers have required fields
            const processedAnswers = validAnswers.map((item, index) => {
                const question = sectionQues[index];
                return {
                    id: item.id || question?._id,
                    answer: props?.currentDimension === 'Demographics' ? (item?.answer || 'Yes') : 
                        (languageUse === 'English' ? item?.answer : 
                        sectionQues?.find(sectionItem => sectionItem?._id === item?.id)?.questionId?.options[
                            sectionQues?.find(sectionItem => sectionItem?._id === item?.id)?.questionId?.options_Malay?.findIndex(optionItem => optionItem === item?.answer)
                        ]),
                    answerMalay: props?.currentDimension === 'Demographics' ? (item?.answer || 'Ya') : 
                        (languageUse === 'English' ? 
                        sectionQues?.find(sectionItem => sectionItem?._id === item?.id)?.questionId?.options_Malay[
                            sectionQues?.find(sectionItem => sectionItem?._id === item?.id)?.questionId?.options?.findIndex(optionItem => optionItem === item?.answer)
                        ] : item?.answer),
                    yesAnswers: getYesAnswers(item, languageUse, props?.currentDimension, sectionQues),
                    otherAnswer: getOtherAnswer(item, languageUse, sectionQues)
                };
            });

            console.log('Submitting answers:', processedAnswers);

            const result = await userProgressAnswerService({
                authToken,
                data: processedAnswers
            });
            
            // Save successful submission to localStorage with timestamp and section info
            const answersToSave = {
                dimensionId: dimensionID,
                dimensionName: props?.currentDimension,
                answers: data.sectionReqAnswers,
                timestamp: new Date().getTime(),
                submitted: true,
                sectionComplete: true
            };
            
            try {
                localStorage.setItem(`progress_answers_${decryptedSubId}_${dimensionID}`, JSON.stringify(answersToSave));
                
                // Save overall progress
                const existingProgress = localStorage.getItem(`progress_overall_${decryptedSubId}`);
                const overallProgress = existingProgress ? JSON.parse(existingProgress) : {};
                overallProgress[dimensionID] = {
                    complete: true,
                    timestamp: new Date().getTime()
                };
                localStorage.setItem(`progress_overall_${decryptedSubId}`, JSON.stringify(overallProgress));
                
                toast.success(result?.data?.data?.message);
                props.setChangeDimensionName(!props.changeDimensionName);
                
                // Check if all sections are complete
                const allSectionsComplete = Object.values(overallProgress).every(section => section.complete);
                if (allSectionsComplete) {
                    setModalShow(true);
                }
            } catch (storageError) {
                console.error('Error saving to localStorage:', storageError);
                // Continue execution even if localStorage fails
            }
            
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.data?.message || 'Something went wrong');
            
            // Attempt to save failed submission for recovery
            try {
                const failedSubmission = {
                    dimensionId: dimensionID,
                    answers: data.sectionReqAnswers,
                    timestamp: new Date().getTime(),
                    error: error?.response?.data?.message || 'Unknown error'
                };
                localStorage.setItem(`failed_submission_${decryptedSubId}_${dimensionID}`, JSON.stringify(failedSubmission));
            } catch (storageError) {
                console.error('Error saving failed submission:', storageError);
            }
        }
    };

    /**
        * @function onSubmit
        * @param data
        * @description submit the answer
    */
    const onSubmit = (data) => {
        if (data) {
            console.log('Form submission data:', data);
            console.log('Section answers:', data.sectionReqAnswers);
            answerSubmit(data);
        } else {
            toast.error('Something went wrong')
        }
    };

    /**
        * @function handleReset
        * @param
        * @description reset all form data
    */
    const handleReset = () => {
        reset();
    };

    useEffect(() => {
        if (sectionQues) {
            const defaultValues = {};
            const secReqDefaultValues = sectionQues.map((item, index) => {
                if (item?.answer) {
                    return {
                        answer: languageUse === 'Malay' && item?.answerMalay ? item?.answerMalay : item?.answer,
                        id: item?._id,
                        yesAnswers: getYesAnswers(item, languageUse, props?.currentDimension, sectionQues),
                        otherAnswer: getOtherAnswer(item, languageUse, sectionQues)
                    };
                }

                // Preserve existing answers if they exist
                if (watchSectionReqAnswers?.[index]) {
                    return watchSectionReqAnswers[index];
                }

                return {
                    answer: item?.answer,
                    id: item?._id,
                    yesAnswers: getYesAnswers(item, languageUse, props?.currentDimension, sectionQues),
                    otherAnswer: getOtherAnswer(item, languageUse, sectionQues)
                };
            });

            defaultValues.sectionReqAnswers = secReqDefaultValues;
            reset(defaultValues);
        }
    }, [sectionQues, languageUse]);

    /**
        * @function backToprevPage
        * @param
        * @description back To previous Page
    */
    const backToprevPage = () => {
        navigate('/')
    }

    const handleCheckboxChange = useCallback((e, questionIndex, statementIndex, option) => {
        const isChecked = e.target.checked;
        const currentAnswers = watchSectionReqAnswers || [];
        
        if (statementIndex !== null) {
            // Handle multi-statement questions
            const currentQuestionAnswers = currentAnswers[questionIndex] || {};
            const currentStatementAnswers = Array.isArray(currentQuestionAnswers[statementIndex]) 
                ? currentQuestionAnswers[statementIndex] 
                : [];
            
            const newStatementAnswers = isChecked 
                ? [...currentStatementAnswers, option]
                : currentStatementAnswers.filter(ans => ans !== option);
            
            const newQuestionAnswers = {
                ...currentQuestionAnswers,
                [statementIndex]: newStatementAnswers,
                id: sectionQues[questionIndex]?._id // Ensure ID is set
            };
            
            const newAnswers = [...currentAnswers];
            newAnswers[questionIndex] = newQuestionAnswers;
            
            setValue('sectionReqAnswers', newAnswers);
        } else {
            // Handle single-statement questions
            const currentQuestionAnswers = Array.isArray(currentAnswers[questionIndex]) 
                ? currentAnswers[questionIndex] 
                : [];
            
            const newQuestionAnswers = isChecked 
                ? [...currentQuestionAnswers, option]
                : currentQuestionAnswers.filter(ans => ans !== option);
            
            const newAnswers = [...currentAnswers];
            newAnswers[questionIndex] = {
                yesAnswers: newQuestionAnswers,
                id: sectionQues[questionIndex]?._id, // Ensure ID is set
                answer: newQuestionAnswers.length > 0 ? 'Yes' : undefined
            };
            
            setValue('sectionReqAnswers', newAnswers);
        }
    }, [watchSectionReqAnswers, setValue, sectionQues]);

    // Update progress calculation to be dimension-specific
    const calculateProgress = () => {
        if (!sectionQues || sectionQues.length === 0) return 0;
        
        const answeredQuestions = sectionQues.filter((item, index) => {
            // First check localStorage for saved answers
            const savedAnswers = localStorage.getItem(`progress_answers_${decryptedSubId}_${dimensionID}`);
            if (savedAnswers) {
                try {
                    const parsedAnswers = JSON.parse(savedAnswers);
                    if (parsedAnswers.answers?.[index]) {
                        return true;
                    }
                } catch (error) {
                    console.error('Error parsing saved answers:', error);
                }
            }
            
            // Then check current form state
            const currentAnswers = watchSectionReqAnswers?.[index];
            
            // Handle different question types
            if (item?.questionId?.questionType === 'checkbox') {
                if (Array.isArray(currentAnswers) && currentAnswers.length > 0) return true;
                
                // Check for multi-statement answers
                if (item?.questionId?.isMultiStatement) {
                    return Object.values(currentAnswers || {}).some(
                        statementAnswers => Array.isArray(statementAnswers) && statementAnswers.length > 0
                    );
                }
            } else if (item?.questionId?.questionType === 'input' || item?.questionId?.questionType === 'calculation') {
                return currentAnswers && currentAnswers.trim() !== '';
            } else if (item?.questionId?.questionType === 'radio') {
                return currentAnswers !== undefined && currentAnswers !== '';
            }
            
            return false;
        }).length;
        
        return Math.round((answeredQuestions / sectionQues.length) * 100);
    };

    // Add effect to update progress when answers change
    useEffect(() => {
        const progress = calculateProgress();
        // Save progress to localStorage
        try {
            const existingProgress = localStorage.getItem(`progress_overall_${decryptedSubId}`);
            const overallProgress = existingProgress ? JSON.parse(existingProgress) : {};
            overallProgress[dimensionID] = {
                progress,
                timestamp: new Date().getTime()
            };
            localStorage.setItem(`progress_overall_${decryptedSubId}`, JSON.stringify(overallProgress));
        } catch (error) {
            console.error('Error saving progress:', error);
        }
    }, [watchSectionReqAnswers, dimensionID, decryptedSubId, sectionQues]);

    // Update the form rendering to handle different question types
    const renderQuestionInput = (item, index) => {
        const questionType = item?.questionId?.questionType || 'checkbox';
        
        switch (questionType) {
            case 'input':
                return (
                    <div className="input-field">
                        <input
                            type="text"
                            className="form-control"
                            value={watchSectionReqAnswers?.[index] || ''}
                            onChange={(e) => {
                                const newAnswers = [...(watchSectionReqAnswers || [])];
                                newAnswers[index] = e.target.value;
                                setValue('sectionReqAnswers', newAnswers);
                            }}
                        />
                    </div>
                );
            
            case 'calculation':
                return (
                    <div className="calculation-field">
                        <input
                            type="number"
                            className="form-control"
                            value={watchSectionReqAnswers?.[index] || ''}
                            onChange={(e) => {
                                const newAnswers = [...(watchSectionReqAnswers || [])];
                                newAnswers[index] = e.target.value;
                                setValue('sectionReqAnswers', newAnswers);
                            }}
                        />
                        {item?.questionId?.calculationFormula && (
                            <div className="calculation-info mt-2">
                                <small className="text-muted">
                                    Formula: {item.questionId.calculationFormula}
                                </small>
                            </div>
                        )}
                    </div>
                );
            
            case 'checkbox':
            default:
                return item?.questionId?.isMultiStatement ? (
                    <div className="multi-statement-options">
                        {item?.questionId?.statements?.map((statement, statementIndex) => (
                            <div key={statementIndex} className="statement-option mb-4">
                                <p className="mb-3 fw-medium">
                                    {languageUse === 'English' ? statement?.statement : statement?.statement_Malay}
                                </p>
                                <div className="d-flex flex-wrap gap-4">
                                    {item?.questionId?.yes_options?.map((option, optionIndex) => (
                                        <div key={optionIndex} className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`option-${index}-${statementIndex}-${optionIndex}`}
                                                checked={Array.isArray(watchSectionReqAnswers?.[index]?.[statementIndex]) && 
                                                    watchSectionReqAnswers[index][statementIndex].includes(option)}
                                                onChange={(e) => handleCheckboxChange(e, index, statementIndex, option)}
                                            />
                                            <label className="form-check-label" htmlFor={`option-${index}-${statementIndex}-${optionIndex}`}>
                                                {option}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="single-statement-options">
                        <div className="d-flex flex-wrap gap-4">
                            {item?.questionId?.yes_options?.map((option, optionIndex) => (
                                <div key={optionIndex} className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`option-${index}-${optionIndex}`}
                                        checked={Array.isArray(watchSectionReqAnswers?.[index]) && 
                                            watchSectionReqAnswers[index].includes(option)}
                                        onChange={(e) => handleCheckboxChange(e, index, null, option)}
                                    />
                                    <label className="form-check-label" htmlFor={`option-${index}-${optionIndex}`}>
                                        {option}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                );
        }
    };

    // Add effect to load saved answers when component mounts or dimension changes
    useEffect(() => {
        const loadSavedAnswers = () => {
            if (sectionQues.length > 0) {
                const savedAnswers = localStorage.getItem(`progress_answers_${decryptedSubId}_${dimensionID}`);
                if (savedAnswers) {
                    try {
                        const parsedAnswers = JSON.parse(savedAnswers);
                        // Only load if the saved answers are for the current dimension
                        if (parsedAnswers.dimensionId === dimensionID) {
                            setValue('sectionReqAnswers', parsedAnswers.answers);
                        }
                    } catch (error) {
                        console.error('Error loading saved answers:', error);
                    }
                }
            }
        };

        loadSavedAnswers();
    }, [dimensionID, decryptedSubId, sectionQues, setValue]);

    // Save answers to localStorage whenever they change
    useEffect(() => {
        if (watchSectionReqAnswers && sectionQues.length > 0) {
            const answersToSave = {
                dimensionId: dimensionID,
                dimensionName: props?.currentDimension,
                answers: watchSectionReqAnswers,
                timestamp: new Date().getTime()
            };
            localStorage.setItem(`progress_answers_${decryptedSubId}_${dimensionID}`, JSON.stringify(answersToSave));
        }
    }, [watchSectionReqAnswers, dimensionID, decryptedSubId, sectionQues.length, props?.currentDimension]);

    // Add completion summary component for Progress Assessment
    const CompletionSummary = () => {
        if (!isAssessmentComplete) return null;

        return (
            <div className="completion-summary">
                <div className="text-center p-5">
                    <div className="completion-icon mb-4">
                        <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
                    </div>
                    <h2 className="mb-3">
                        {languageUse === 'English' ? 'Progress Assessment Completed!' : 'Évaluation des progrès terminée !'}
                    </h2>
                    <p className="lead mb-4">
                        {languageUse === 'English' 
                            ? 'Congratulations! You have successfully completed your Progress Assessment. You can now compare your results with previous assessments.'
                            : 'Félicitations ! Vous avez terminé avec succès votre évaluation des progrès. Vous pouvez maintenant comparer vos résultats avec les évaluations précédentes.'}
                    </p>
                    
                    <div className="completion-stats mb-4">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="stat-item">
                                    <h4>{sectionQues?.length || 0}</h4>
                                    <p>{languageUse === 'English' ? 'Questions' : 'Questions'}</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="stat-item">
                                    <h4>100%</h4>
                                    <p>{languageUse === 'English' ? 'Complete' : 'Terminé'}</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="stat-item">
                                    <h4>{new Date().toLocaleDateString()}</h4>
                                    <p>{languageUse === 'English' ? 'Completed' : 'Terminé le'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="completion-actions">
                        <Button 
                            variant="outline-primary" 
                            className="me-3"
                            onClick={() => {
                                // Show questions for review
                                setIsAssessmentComplete(false);
                            }}
                        >
                            <i className="bi bi-eye me-2"></i>
                            {languageUse === 'English' ? 'Review Answers' : 'Réviser les Réponses'}
                        </Button>
                        
                        <Button 
                            variant="success"
                            onClick={() => {
                                const encryptedId = CryptoJS.AES.encrypt(decryptedSubId, 'mySecretKey').toString();
                                navigate(`/user/dashboard/${encryptedId}`);
                            }}
                        >
                            <i className="bi bi-graph-up me-2"></i>
                            {languageUse === 'English' ? 'View Progress Results' : 'Voir les résultats des progrès'}
                        </Button>
                    </div>

                    {/* Progress Assessment Specific Next Steps */}
                    <div className="next-steps mt-4">
                        <h4 className="mb-3">
                            {languageUse === 'English' ? 'What would you like to do next?' : 'Que souhaitez-vous faire ensuite ?'}
                        </h4>
                        
                        <div className="next-steps-options">
                            <Button 
                                variant="info"
                                className="me-3 mb-2"
                                onClick={() => {
                                    // Navigate to start another Progress Assessment
                                    navigate('/user/history');
                                }}
                            >
                                <i className="bi bi-graph-up-arrow me-2"></i>
                                {languageUse === 'English' ? 'Start Another Progress Assessment' : 'Commencer une autre évaluation des progrès'}
                            </Button>
                            <Button 
                                variant="outline-secondary"
                                className="mb-2"
                                onClick={() => {
                                    // Navigate back to Readiness Assessment
                                    navigate('/user/history');
                                }}
                            >
                                <i className="bi bi-arrow-left me-2"></i>
                                {languageUse === 'English' ? 'Return to Readiness Assessment' : 'Retourner à l\'évaluation de préparation'}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // Note: Automatic completion detection removed to prevent premature assessment completion

    // Note: Automatic completion status loading removed to prevent premature completion

    // Clear completion status when starting a new assessment
    useEffect(() => {
        if (sectionQues?.length > 0) {
            // Clear any existing completion status when starting a new assessment
            const existingCompletion = localStorage.getItem(`progress_assessment_complete_${decryptedSubId}_${dimensionID}`);
            if (existingCompletion === 'true') {
                console.log('Clearing existing completion status for new progress assessment');
                localStorage.removeItem(`progress_assessment_complete_${decryptedSubId}_${dimensionID}`);
                setIsAssessmentComplete(false);
            }
        }
    }, [decryptedSubId, dimensionID, sectionQues]);

    /**
     * @function resetProgressAssessment
     * @description Manually reset progress assessment completion status
     */
    const resetProgressAssessment = () => {
        localStorage.removeItem(`progress_assessment_complete_${decryptedSubId}_${dimensionID}`);
        setIsAssessmentComplete(false);
        reset();
        toast.success(languageUse === 'English' ? 'Progress assessment reset' : 'Évaluation des progrès réinitialisée');
    };

    /**
     * @function startNewProgressAssessment
     * @description Clear all data and start fresh progress assessment
     */
    const startNewProgressAssessment = () => {
        // Clear all localStorage data for this progress assessment
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.includes(`${decryptedSubId}_${dimensionID}`)) {
                keysToRemove.push(key);
            }
        }
        
        keysToRemove.forEach(key => localStorage.removeItem(key));
        
        // Reset component state
        setIsAssessmentComplete(false);
        reset();
        
        toast.success(languageUse === 'English' ? 'Starting fresh progress assessment' : 'Démarrage d\'une nouvelle évaluation des progrès');
    };

    return (
        <StyledQuestionPage className="p-4">
            {isQuestionLoading ? (
                <div className="text-center p-5">
                    <Spinner color="primary" />
                    <p className="mt-2">Loading questions...</p>
                </div>
            ) : !sectionQues || sectionQues.length === 0 ? (
                <div className="text-center p-5">
                    <div className="alert alert-warning">
                        No questions found for this dimension. Please try refreshing the page or contact support if the issue persists.
                    </div>
                </div>
            ) : isAssessmentComplete ? (
                <CompletionSummary />
            ) : (
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
                    {/* Progress indicator */}
                    <div className="progress-indicator mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h4 className="mb-0">
                                {languageUse === 'English' ? props.currentDimension : props.currentDimension_Malay}
                            </h4>
                            <div className="d-flex align-items-center gap-2">
                                <span className="progress-text">
                                    {calculateProgress()}% Complete
                                </span>
                                <Button 
                                    variant="outline-warning"
                                    onClick={resetProgressAssessment}
                                    size="sm"
                                >
                                    Reset
                                </Button>
                                <Button 
                                    variant="outline-info"
                                    onClick={startNewProgressAssessment}
                                    size="sm"
                                >
                                    Start Fresh
                                </Button>

                            </div>
                        </div>
                        <ProgressBar 
                            now={calculateProgress()} 
                            label={`${calculateProgress()}%`}
                            className="progress-bar-custom"
                        />
                    </div>

                    {/* Dimension and Indicator Information */}
                    <div className="question-header mb-4">
                        <h2 className="dimension-title mb-3">
                            {languageUse === 'English' ? props.currentDimension : props.currentDimension_Malay}
                        </h2>
                        {props.selectedIndicator && (
                            <div className="indicator-info bg-light p-3 rounded">
                                <h4 className="mb-2">{props.selectedIndicator?.name}</h4>
                                <p className="text-muted mb-0">{props.selectedIndicator?.description}</p>
                            </div>
                        )}
                    </div>

                    {/* Questions Container */}
                    <div className="questions-container">
                        {sectionQues.map((item, index) => (
                            <div className="question-section card mb-4" key={item?._id || index}>
                                <div className="card-body">
                                    {/* Section Title if available */}
                                    {item?.sectionId && (
                                        <div className="section-header mb-3">
                                            <h3 className="section-title">
                                                {languageUse === 'English' ? item.sectionId.name : item.sectionId.name_Malay}
                                            </h3>
                                            {item.sectionId.description && (
                                                <p className="section-description text-muted">
                                                    {languageUse === 'English' ? item.sectionId.description : item.sectionId.description_Malay}
                                                </p>
                                            )}
                                        </div>
                                    )}

                                    <div className="question-title d-flex align-items-start">
                                        <span className="me-2 fw-bold">{index + 1}.</span>
                                        <div className="flex-grow-1">
                                            <div>
                                                <span className="fs-5">
                                                    {languageUse === 'English' ? item?.questionId?.question : item?.questionId?.question_Malay}
                                                </span>
                                                {!item?.isOptional && <span className="text-danger ms-1">*</span>}
                                            </div>
                                            {(item?.questionId?.toolTip || item?.questionId?.toolTip_Malay) && (
                                                <div className="tooltip mt-2">
                                                    <RiErrorWarningFill size={20} className="text-primary" />
                                                    <span className="tooltip-text ms-2 text-muted">
                                                        {languageUse === 'English' ? item?.questionId?.toolTip : item?.questionId?.toolTip_Malay}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="options-list mt-4">
                                        {renderQuestionInput(item, index)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="submit-section text-center mt-4">
                        <Button 
                            type="submit" 
                            variant="primary" 
                            size="lg"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Submitting...' : 'Submit Answers'}
                        </Button>
                    </div>
                </form>
            )}
            
            {/* Modals */}
            <SubmissionEndModal 
                show={modalShow} 
                handleClose={handleModalShow} 
                submission_id={decryptedSubId} 
                questionPage={true} 
                decryptedSubId={decryptedSubId} 
            />
            <UploadedDocumentsModal 
                modal={uploadedDocumentsModal} 
                toggle={UploadedDocumentsModaltoggle} 
                handleShowPdfModalShow={handleShowPdfModalShow} 
                submissionId={decryptedSubId} 
                setPdfItem={setPdfItem} 
            />
            <ShowPdfModal 
                show={showPdfModalShow} 
                handleClose={handleShowPdfModalShow} 
                pdfItem={pdfItem} 
            />
            
            <Toaster position="top-right" />
        </StyledQuestionPage>
    );
};

export default ProgressQuestionPage;
